import * as yup from 'yup';

import { OperationFields } from '../../../../../operationsTypes';
import {
  LOA_START_HOURS,
  LOA_END_HOURS
} from '../../../../../operationsConstants';

import { formsErrors } from '../../../../../../../locales/keys';

function checkDateHours(value: string | Date, startHours, endHours) {
  if (!value) {
    return false;
  }
  const date = new Date(value);
  const hours = date.getHours();
  const minutes = date.getMinutes();

  if (hours === endHours && minutes === 0) {
    return true;
  }

  return hours >= startHours && hours < endHours;
}

export const createOperationFormSchema = yup.object().shape({
  [OperationFields.BODY]: yup
    .string()
    .nullable()
    .required(formsErrors.required),
  [OperationFields.COMPLETE_DATETIME]: yup
    .date()
    .nullable()
    .required(formsErrors.required)
    .test('from10To19', formsErrors.time.from10To19, (value) =>
      checkDateHours(value, LOA_START_HOURS, LOA_END_HOURS)
    ),
  [OperationFields.DATE]: yup
    .date()
    .nullable()
    .required(formsErrors.required)
    .min(
      yup.ref(OperationFields.COMPLETE_DATETIME),
      formsErrors.toDate.laterThanFrom
    )
    .test('from10To19', formsErrors.time.from10To19, (value) =>
      checkDateHours(value, LOA_START_HOURS, LOA_END_HOURS)
    ),
  [OperationFields.SUBJECT]: yup.string().required(formsErrors.required),
  [OperationFields.CLIENT_ID]: yup
    .string()
    .nullable()
    .required(formsErrors.required)
});
